export const PARTNER_ID = 'DEFENCELOGIC';
export const PARTNER_DISPLAY_NAME = 'Defence Logic';
export const SUPPORT_EMAIL = 'info@defencelogic.io';
export const PRODUCT_NAME = 'Cloudaudit';

export const AUTH_CONFIG = {
  ENTRA_CLIENT_ID: '47ed85ed-ed58-449a-8fa6-fd5363758422',
  DEFENDER_CLIENT_ID: 'aca1f752-57c4-44c8-a1b3-d8badf18c493',
  AZURE_CLIENT_ID: '30b554b1-caad-4397-9e32-7cf201f21a90',
} as const;

export const COGNITO_CONFIG = {
  CLIENT_ID: '63njivtgsgji320ral869utaq5',
  USER_POOL_ID: 'eu-west-2_9NN3lz5Iq',
  REGION: 'eu-west-2',
  DOMAIN: 'sso.quickcheck.strata-host.co.uk',
  PARTNER_ADMIN_GROUP: 'partner_admin',
  IDENTITY_POOL_ID: 'eu-west-2:c8c5d69c-a987-4fea-89e8-07bad75cecd6'
} as const;

export const S3_CONFIG = {
  BUCKET_NAME: 'strata-quickcheck-defencelogic-reports',
  REGION: 'eu-west-2'
} as const;
